import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  grey1,
  grey2,
  grey5,
  grey4,
} from 'approot/shared/styles/colours.style';
import { spacing20 } from 'approot/shared/styles/spacing.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { FileDropperImageField } from 'lib/form/file-dropper/file-dropper-image.style';
import { viewport16by9Ratio, viewportMaxCss } from '../shared/playable.style';

export const SlideshowUploadWrapper = styled.div`
  ${viewportMaxCss}

  background-color: ${grey2};
  border-radius: ${rem(borderRadius8)};
  border: 1px solid ${grey5};
  position: relative;
  width: 100%;
`;

export const SlideshowUploadAspectRatio = styled.div`
  ${viewport16by9Ratio}
`;

export const SlideshowUpload = styled.div`
  background-color: ${grey1};
  border: 1px dashed ${grey4};
  border-radius: ${rem(borderRadius8)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${rem(spacing20)};
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;

  ${FileDropperImageField} {
    height: 100%;
    margin: 0;
    max-width: none;
  }
`;
